import React from 'react';
import { ArrowRight } from 'lucide-react';
const cards = [{
  title: 'MARINE',
  image: 'https://images.unsplash.com/photo-1559325988-825026938b81?q=80&w=800&auto=format&fit=crop',
  description: 'Shipyard and marine construction opportunities for welders, pipefitters, electricians, and other skilled trades professionals.'
}, {
  title: 'INDUSTRIAL',
  image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?q=80&w=800&auto=format&fit=crop',
  description: 'Plant maintenance, turnaround, and capital project roles in petrochemical, refining, and manufacturing facilities.'
}, {
  title: 'CONSTRUCTION',
  image: 'https://images.unsplash.com/photo-1590846083693-f23fdede3a7e?q=80&w=800&auto=format&fit=crop',
  description: 'Commercial and heavy civil construction positions requiring experienced equipment operators, carpenters, and concrete workers.'
}];
export function ExploreOpportunities() {
  return <section className="py-24 px-6 md:px-12 bg-dark text-white relative overflow-hidden" data-id="element-25">
      {/* Decorative angled background element */}
      <div className="absolute top-0 left-0 w-full h-32 bg-primary transform -skew-y-2 origin-top-left -z-0 opacity-10" data-id="element-26"></div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-27">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-28">
          <div className="max-w-2xl" data-id="element-29">
            <div className="section-badge text-white" data-id="element-30">AVAILABLE JOBS</div>
            <h2 className="text-4xl md:text-5xl font-bold leading-tight" data-id="element-31">
              EXPLORE OPPORTUNITIES{' '}
              <span className="text-primary" data-id="element-32">IN SKILLED TRADES</span>
            </h2>
          </div>
          <a href="#" className="flex items-center gap-2 text-white font-heading font-semibold uppercase tracking-wider hover:text-primary transition-colors group" data-id="element-33">
            ALL JOBS
            <div className="bg-primary text-white rounded-full p-1 group-hover:bg-primary-hover transition-colors" data-id="element-34">
              <ArrowRight size={16} data-id="element-35" />
            </div>
          </a>
        </div>

        <p className="text-gray-400 text-lg mb-12 max-w-3xl" data-id="element-36">
          We maintain a vast network of ongoing projects across the region,
          ensuring consistent work for our craftsmen. Explore our core divisions
          to find the right fit for your skills and experience.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-37">
          {cards.map((card, index) => <div key={index} className="bg-dark-lighter border border-gray-800 flex flex-col group hover:border-primary transition-colors duration-300" data-id="element-38">
              <div className="h-64 overflow-hidden" data-id="element-39">
                <img src={card.image} alt={card.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-40" />
              </div>
              <div className="p-8 flex-grow flex flex-col relative" data-id="element-41">
                {/* Left blue accent line */}
                <div className="absolute left-0 top-8 bottom-8 w-1 bg-primary" data-id="element-42"></div>

                <h3 className="text-2xl font-bold mb-4 pl-4" data-id="element-43">{card.title}</h3>
                <p className="text-gray-400 mb-8 pl-4 flex-grow" data-id="element-44">
                  {card.description}
                </p>

                <button className="btn-primary w-full mt-auto" data-id="element-45">
                  {card.title}
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}